import { useEffect, useRef } from "react";
import suneditor from "suneditor";
import plugins from "suneditor/src/plugins";
import "suneditor/dist/css/suneditor.min.css";

const buttonList = [
  ["undo", "redo"],
  ["font", "fontSize", "formatBlock"],
  ["paragraphStyle", "blockquote"],
  ["bold", "underline", "italic", "strike", "subscript", "superscript"],
  ["fontColor", "hiliteColor", "textStyle"],
  ["removeFormat"],
  "/",
  ["outdent", "indent"],
  ["align", "horizontalRule", "list", "lineHeight"],
  ["table", "link", "image", "video", "audio"],
  ["imageGallery"],
  ["fullScreen", "showBlocks", "codeView"],
  ["preview", "print", "save"],
];

const SunEditor = ({ defaultValue = "", onChange, height = "calc(100vh - 330px)" }) => {
  const editorElement = useRef(null);
  const editor = useRef(null);

  useEffect(()=>{
    if(editor.current){
      editor.current.setContents(defaultValue || "");
    }
  },[defaultValue]);

  useEffect(() => {
    if (!editorElement.current) return undefined;

    const instance = suneditor.create(editorElement.current, {
      value:defaultValue,
      plugins,
      buttonList,
      minHeight: height,
      width: "100%",
      popupDisplay: "full",
      resizingBar: true,
      imageResizing: true,
      imageAlignShow: true,
      imageFileInput: true,
      imageUrlInput: true,
      videoFileInput: true,
      audioFileInput: true,
      linkProtocol: "https://",
      shortcutsDisable: [],
      pasteTagsWhitelist: "all",
      attributesWhitelist: {
        all: "style|class|id|data-.+|title",
        img: "src|alt|width|height|style|class|data-.+",
        a: "href|target|rel|style|class|title",
      },
      defaultTag: "p",
      defaultStyle: "font-family: Inter, ui-sans-serif, system-ui, sans-serif; font-size: 14px;",
    });

    instance.onChange = (contents) => {
      onChange?.(contents);
    };
    editor.current = instance;

    return () => {
      instance.destroy();
      editor.current = null;
    };
  }, []);

  useEffect(() => {
    if (!editor.current || editor.current.getContents() === defaultValue) return;
    editor.current.setContents(defaultValue || "");
  }, [defaultValue]);

  return <textarea ref={editorElement} />;
};

export default SunEditor;
